import axios from 'axios'
import store from '@/store/store'
// import router from '@/router'

let requestNumber = 0

const request = (method, url, data, noLoading) => {
  // !noLoading && store.commit('toggleLoading', true)
  if (!noLoading) {
    document.getElementById('loading').style.display = 'block'
  }
  const send = axios.create()
  send.interceptors.request.use(config => {
    requestNumber++
    const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).Token : ''
    if (token) {
      config.headers.Authorization = token
    }
    return config
  }, err => {
    return Promise.reject(err)
  })

  send.interceptors.response.use(response => {
    requestNumber--
    // store.commit('toggleLoading', false)
    if (requestNumber <= 0) {
      document.getElementById('loading').style.display = 'none'
    }
    return response.data
  }, error => {
    requestNumber--
    // store.commit('toggleLoading', false)
    if (requestNumber <= 0) {
      document.getElementById('loading').style.display = 'none'
    }
    if (error && error.response && error.response.status === 401) {
      // router.push('/Login')
      store.commit('toggleLogin', true)
    }
    // return error.response // 返回接口返回的错误信息
    return Promise.reject(error.response) // 返回接口返回的错误信息
  })

  return send({method, url, data})
}

export default request



// WEBPACK FOOTER //
// ./src/service/index.js